export default __webpack_public_path__ + "static/5b)UhOhhh-b3b6c7ba09904293b0919fcb07e7f574.mp3";